module.exports = __webpack_public_path__ + "img/dance-school-icon1.9068f484.png";